import moment from 'moment';
import { Page } from '../model/elements';
import { TaskMemberAction } from '../model/entities';
import adminApiAxios from './CustomAxios';

class TaskMemberActionApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskId: number,
        searchText?: string,
    ): Promise<Page<TaskMemberAction>> => {
        const response = await adminApiAxios.get<Page<TaskMemberAction>>('/task-member-actions', {
            params: { page, size, sortField, sortOrder, taskId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };
}

const taskMemberActionApi: TaskMemberActionApi = new TaskMemberActionApi();
export default taskMemberActionApi;
